<div class="not-found-container">
  <div class="not-found-content">
    <img src="/images/icons/not-found.webp" alt="404 not found" />
    <h1 class="not-found-title">Error!</h1>
    <p class="not-found-message">
      Thank you for Your interest in this page. the Page you're looking for
      isn't Available Right Now. Please Check Back Later.
    </p>
    <a routerLink="/" class="home-link">Back to Home</a>
  </div>
</div>
